import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface BadgeProps {
  variant?: "default" | "success" | "warning" | "error";
  children: ReactNode;
  className?: string;
}

const variantStyles = {
  default: "bg-accent-blue/20 text-black border-accent-blue/40 dark:text-white",
  success: "bg-accent-green/20 text-accent-green border-accent-green/40",
  warning: "bg-accent-yellow/20 text-black border-accent-yellow/40",
  error: "bg-brand-coral/20 text-brand-coral-dark border-brand-coral/40",
};

export function Badge({ variant = "default", children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold",
        variantStyles[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
